import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Search, Users } from "lucide-react";
import { toast } from "sonner";
import { apiCall, fmtDate } from "./calendar/calendarUtils";
import { CustomerProfile } from "./customers/CustomerProfile";
import { AppointmentDialog } from "./calendar/AppointmentDialog";

export default function KundenTab({ adminToken: token }) {
  const [q, setQ] = useState("");
  const [list, setList] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [apt, setApt] = useState(null);

  useEffect(() => {
    const t = setTimeout(() => {
      apiCall(token, `/customers/admin?q=${encodeURIComponent(q)}`).then((d) => setList(d.customers)).catch((e) => toast.error(e.message));
    }, 250);
    return () => clearTimeout(t);
  }, [token, q]);

  const openAppointment = async (a) => setApt(await apiCall(token, `/calendar/admin/appointments/${a.appointment_id}`));

  return (
    <div data-testid="kunden-tab">
      <div className="flex flex-wrap items-center gap-3 mb-4">
        <h2 className="font-['Bebas_Neue'] text-2xl text-white flex items-center gap-2"><Users className="w-5 h-5 text-[#c1ff72]" />Kunden <span className="text-[#71717A] text-lg">({list.length})</span></h2>
        <div className="relative w-full sm:w-auto sm:ml-auto">
          <Search className="w-4 h-4 absolute left-2 top-3 text-[#71717A]" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Name, Spieler, Telefon oder E-Mail" className="h-10 pl-8 w-full sm:w-72 bg-[#1A1A1A] border-white/10 text-white" data-testid="customer-search" />
        </div>
      </div>
      <div className="md:hidden space-y-2" data-testid="customer-cards">
        {list.map((c) => (
          <button key={c.customer_id} type="button" onClick={() => setOpenId(c.customer_id)} className="w-full text-left bg-[#121212] border border-white/10 p-3 active:bg-white/5" data-testid={`customer-card-${c.customer_id}`}>
            <div className="flex justify-between gap-2"><span className="text-white font-medium">{c.name || c.email}</span><span className="text-xs text-[#c1ff72]">{c.upcoming} anstehend</span></div>
            <div className="text-xs text-[#A1A1AA] truncate">{c.player_names.length ? `Spieler: ${c.player_names.join(", ")} · ` : ""}{c.phone || c.email}</div>
            <div className="text-[11px] text-[#71717A]">{c.total_bookings} Buchungen · zuletzt {fmtDate(c.last_date) || "–"}</div>
          </button>
        ))}
      </div>
      <div className="overflow-x-auto hidden md:block">
        <table className="w-full text-sm" data-testid="customer-table">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-[#71717A] border-b border-white/10">
            <th className="py-2 pr-3">Kunde</th><th className="py-2 pr-3">Spieler</th><th className="py-2 pr-3">Kontakt</th><th className="py-2 pr-3 text-right">Buchungen</th><th className="py-2 pr-3 text-right">Anstehend</th><th className="py-2 text-right">Letzter Termin</th>
          </tr></thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.customer_id} onClick={() => setOpenId(c.customer_id)} className="border-b border-white/5 hover:bg-white/[0.03] cursor-pointer" data-testid={`customer-row-${c.customer_id}`}>
                <td className="py-2.5 pr-3 text-white font-medium">{c.name || "–"}</td>
                <td className="py-2.5 pr-3 text-[#A1A1AA]">{c.player_names.join(", ") || "–"}</td>
                <td className="py-2.5 pr-3 text-[#A1A1AA]"><div>{c.email}</div><div className="text-xs">{c.phone}</div></td>
                <td className="py-2.5 pr-3 text-right text-white">{c.total_bookings}</td>
                <td className="py-2.5 pr-3 text-right text-[#c1ff72]">{c.upcoming}</td>
                <td className="py-2.5 text-right text-[#A1A1AA]">{fmtDate(c.last_date) || "–"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!list.length && <p className="text-center text-[#71717A] py-10" data-testid="customer-empty">Keine Kunden gefunden</p>}
      </div>
      {openId && <CustomerProfile token={token} customerId={openId} onClose={() => setOpenId(null)} onOpenAppointment={openAppointment} />}
      <AppointmentDialog token={token} event={apt} onClose={() => setApt(null)} onChanged={() => setApt(null)} />
    </div>
  );
}
